<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：状态列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleStateSelect('')"
              :class="{ 'selected': inoutOrderManageInfo.conditions.state === '' }">
              全部
            </li>
            <li v-for="(item, index) in inoutOrderManageInfo.states" :key="index"
              @click="handleStateSelect(item.statusCd)"
              :class="{ 'selected': inoutOrderManageInfo.conditions.state === item.statusCd }">
              {{ item.name }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form :inline="true" :model="inoutOrderManageInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input v-model="inoutOrderManageInfo.conditions.personName" placeholder="请输入申请人名称" clearable />
            </el-form-item>
            <el-form-item>
              <el-input v-model="inoutOrderManageInfo.conditions.orderId" placeholder="请输入单号" clearable />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="inoutOrderManageInfo.conditions.queryStartTime"
                type="date"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                clearable
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="inoutOrderManageInfo.conditions.queryEndTime"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                clearable
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryInoutOrderMethod">
                <i class="el-icon-search"></i> 查询
              </el-button>
              <el-button @click="_resetInoutOrderMethod">
                <i class="el-icon-refresh"></i> 重置
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 入库单信息表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>入库单信息</span>
          </div>
          <el-table :data="inoutOrderManageInfo.inoutOrders" border style="width:100%">
            <el-table-column prop="orderId" label="订单ID" align="center" />
            <el-table-column prop="prodName" label="商品" align="center" />
            <el-table-column prop="personName" label="申请人" align="center" />
            <el-table-column prop="createTime" label="创建时间" align="center" />
            <el-table-column prop="remark" label="备注" align="center" />
            <el-table-column prop="stateName" label="状态" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button v-if="scope.row.state == '3003'" type="text" size="small" @click="_doOrderIn(scope.row)">
                  入库
                </el-button>
                <el-button type="text" size="small" @click="_toDetail(scope.row)">
                  详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next" :total="inoutOrderManageInfo.total"
            style="margin-top:20px;text-align:right" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryInoutOrder } from '@/api/goods/inoutOrderApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'InoutOrderManage',
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      inoutOrderManageInfo: {
        inoutOrders: [],
        total: 0,
        records: 1,
        states: [],
        conditions: {
          personName: '',
          orderId: '',
          shopId: '',
          orderType: '10000',
          state: '',
          queryStartTime: '',
          queryEndTime: ''
        }
      }
    }
  },
  created() {
    this.shopId = getShopId()
    this.inoutOrderManageInfo.conditions.shopId = this.shopId
    console.log(this.shopId)
    this._listInoutOrders(1, this.pageSize)
    this._getDictData()
  },
  methods: {
    async _getDictData() {
      try {
        const { data } = await getDict('inout_order', 'state')
        this.inoutOrderManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listInoutOrders(page, rows) {
      this.inoutOrderManageInfo.conditions.page = page
      this.inoutOrderManageInfo.conditions.row = rows
      try {
        const res = await queryInoutOrder(this.inoutOrderManageInfo.conditions)
        this.inoutOrderManageInfo.total = res.total
        this.inoutOrderManageInfo.records = res.records
        this.inoutOrderManageInfo.inoutOrders = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryInoutOrderMethod() {
      this._listInoutOrders(1, this.pageSize)
    },
    _resetInoutOrderMethod() {
      this.inoutOrderManageInfo.conditions.personName = ''
      this.inoutOrderManageInfo.conditions.orderId = ''
      this.inoutOrderManageInfo.conditions.state = ''
      this.inoutOrderManageInfo.conditions.queryStartTime = ''
      this.inoutOrderManageInfo.conditions.queryEndTime = ''
      this._listInoutOrders(1, this.pageSize)
    },
    handleStateSelect(state) {
      this.inoutOrderManageInfo.conditions.state = state
      this.currentPage = 1
      this._listInoutOrders(1, this.pageSize)
    },
    _toDetail(inoutOrder) {
      this.$router.push(`/pages/goods/upShopHouseDetail?orderId=${inoutOrder.orderId}`)
    },
    _doOrderIn(inoutOrder) {
      this.$router.push(`/pages/goods/doOrderDetailIn?orderId=${inoutOrder.orderId}`)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listInoutOrders(val, this.pageSize)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.margin-top-sm {
  margin-top: 20px;
}
</style>